import 'whatwg-fetch';
import $ from 'jquery';

const DISTRICT = 'https://www.rcsdk8.org';
const PAGE = 'district-resource/district-links';

export default class DistrictMenu {
  constructor(element, selector) {
    this.element = element;
    this.sourceSelector = selector;
    this.success = this.success.bind(this);
    this.fail = this.fail.bind(this);

    // Append a link to house a way back to the district
    // and a home for the district links we're requesting next.
    // @NOTE: This link needed to be placed right away to enable the menu
    //   functionality. We can't wait for the request to complete.
    this.$parent = this.createParentItem();
    this.$parent.appendTo(this.element);

    const url = new Request(`${DISTRICT}/${PAGE}`);
    const options = {
      method: 'GET',
      mode: 'cors',
      cache: 'default',
    };

    // Request district homepage.
    fetch(url, options)
      .then(this.validate)
      .then(this.success)
      .catch(this.fail);
  }

  // Validate response from our request.
  /* eslint-disable class-methods-use-this */
  validate(response) {
    if (!response.ok) {
      throw Error(response.statusText);
    }
    return response.text();
  }

  // Display an error message if the request failed.
  fail(error) {
    this.error = error;
  }

  // Pass off the response text to the parse it for our output.
  success(result) {
    // Content should be an unordered list of links.
    const $content = $(result).find(this.sourceSelector);
    // Links within this list.
    const $links = $content.find('li a');
    // Add class helpers to each link so they display properly in the menu.
    $links.addClass('menu-link depth-2');
    // Transition link destinations from relative to absolute.
    $content.find('a').filter('[href^="/"]').each((i, component) => {
      $(component).attr('href', (ii, value) => `${DISTRICT}${value}`);
    });
    // Add in our links we requested from the district site.
    $content.appendTo(this.$parent);
  }

  // Utility to create our parent list item and link back to the district.
  createParentItem() {
    return $(`
      <li class="menuparent depth-1">
        <a href="${DISTRICT}" title="District" class="menu-link depth-1">
          <span class="menu-title">District</span>
        </a>
      </li>
    `);
  }
}



// WEBPACK FOOTER //
// ./DistrictMenu.js